import {Hero} from '@primer/react-brand-next'

import {getImageSources, MAX_CONTENT_WIDTH} from '@github-ui/swp-core/lib/utils/images'

import type {FlexSuiteStackedHeroProps} from './types'
import {getDescription, getHeading} from './utils'

/**
 * Stacked hero: center-aligned with a block-end image
 */
export function FlexSuiteHeroStacked({fields}: {fields: FlexSuiteStackedHeroProps}) {
  const {heroHeading, heroLabel, heroDescription, heroCtaOne, heroCtaTwo, heroImage, options} = fields

  return (
    <Hero variant={options.variant} align="center">
      {heroLabel && <Hero.Label>{heroLabel}</Hero.Label>}
      <Hero.Heading>{getHeading(heroHeading)}</Hero.Heading>
      <Hero.Description>{heroDescription ? getDescription(heroDescription) : null}</Hero.Description>
      <Hero.PrimaryAction href={heroCtaOne.fields.href}>{heroCtaOne.fields.text}</Hero.PrimaryAction>
      {heroCtaTwo && (
        <Hero.SecondaryAction href={heroCtaTwo.fields.href}>{heroCtaTwo.fields.text}</Hero.SecondaryAction>
      )}
      {heroImage && (
        <Hero.Image
          as="picture"
          src={`${heroImage.fields.file.url}?fm=webp`}
          sources={getImageSources(heroImage.fields.file.url, {maxWidth: MAX_CONTENT_WIDTH, disableDprScaling: true})}
          alt={heroImage.fields.description ?? ''}
          enableBorder={false}
        />
      )}
    </Hero>
  )
}
